/**
 * CBAC permission gating engineering-level Super Admin Tools.
 *
 * `sudo` is associated to no role — it is granted per person via
 * `public.permission_person_override` (`effect = 'GRANT'`), so holding the Super Admin
 * role does not imply it.
 */
export const SUDO = 'sudo';

const SUDO_PERMISSION_NAME = SUDO.toLowerCase();

/**
 * True only when `sudo` is among the caller's granted permissions.
 *
 * Reads the granted-permission list directly rather than going through `isPermitted`,
 * which returns true for everything when the CBAC flag is off. A capability this broad
 * must fail closed instead of opening up in CBAC-off environments. Comparison is
 * case-insensitive because the catalog's `permissionName` casing is set by Janus.
 */
export const hasSudoPermission = (permissions, permissionIds) =>
  Boolean(
    permissions?.some(
      (permission) =>
        permission?.permissionName?.toLowerCase() === SUDO_PERMISSION_NAME &&
        permissionIds?.includes(permission.permissionId)
    )
  );
